import { render, staticRenderFns } from "./CommentStatistics.vue?vue&type=template&id=2e800b41"
import script from "./CommentStatistics.vue?vue&type=script&lang=js"
export * from "./CommentStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports